<template>
  <div
    class="d-flex justify-content-center align-items-center w-100 h-100"
    v-if="isCalling"
  >
    <spinner></spinner>
  </div>

  <form
    class="Form Form--profile container-fluid"
    v-else
  >
    <div
      v-for="userNotification in userNotifications"
      :key="userNotification.id"
      class="row mb-4 align-items-center"
    >
      <div class="col-12 col-sm-8 d-flex flex-column">
        <span>{{ $t(`user_profile_settings_${userNotification.code}`) }}</span>
        <span class="u-gray">{{ $t(`user_profile_settings_${userNotification.code}_comment`) }}</span>
      </div>
      <div class="col-5 col-sm-2 d-flex justify-content-center">
        <toggle-switch
          :id="userNotification.code"
          :label="'user_profile_settings_email'"
          updateOnChange
          @change="setUserSettings(userNotification, 'email')"
          :status="userNotification.email"
        ></toggle-switch>

      </div>
      <div
        class="col-5 col-sm-2 d-flex justify-content-center"
        v-if="!excludeOptionFromPhoneSettings(userNotification)"
      >
        <toggle-switch
          :id="'account-low-balance-mobile'"
          :label="'user_profile_settings_mobile'"
          :status="userNotification.mobile"
          @change="setUserSettings(userNotification, 'mobile')"
          updateOnChange
        ></toggle-switch>

      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12 d-flex flex-column">
        <span>{{$t('user_profile_settings_language')}}</span>
        <div class="multiselect-filter">
          <multi-select-input
            :options="languageList"
            :customLabelField="'code'"
            :value="userLanguage"
            translateLabel
            @inputSelected="changeLanguage($event)"
            :translateLabelAdditionalKey="'user_settings_language__'"
            :placeholder="$t('user_profile_settings_language')"
          />
        </div>
      </div>
    </div>
    <div class="p-5"></div>
    <div class="p-5"></div>

  </form>
</template>

<script>
import ToggleSwitch from '@/components/Commons/Forms/ToggleSwitch'
import Spinner from '@/components/Commons/Spinner'
import MultiSelectInput from '@/components/Commons/Forms/MultiSelectInput'
import { setLanguage } from '@/locales/'
import { languageList } from '../../../../locales/_constants/lang'
export default {
  name: 'UserPreferencesForm',
  data () {
    return {
      isCalling: false,
      userLanguage: ''
    }
  },
  components: {
    ToggleSwitch, Spinner, MultiSelectInput
  },
  computed: {
    userId () {
      return this.$store.getters['LoginStore/loggedUserId']
    },
    languageList () {
      return languageList
    },
    userLocale () {
      return this.$store.getters['UsersStore/userLocale']
    },
    userNotifications () {
      return this.$store.getters['UsersStore/userNotifications']
    },
    excludedAppSettings () {
      return ['WEEKLY_PENDING_REVIEW_TRANSACTION']
    }
  },
  methods: {
    excludeOptionFromPhoneSettings (setting) {
      if (setting) {
        return this.excludedAppSettings.findIndex(el => el === setting.code) > -1
      }
    },
    async getUserSettings () {
      try {
        this.isCalling = true
        this.$store.dispatch('UsersStore/fetchUserNotifications')
        this.userLanguage = languageList.find(el => el.locale === this.userLocale)
      } catch (error) {
        console.error(error)
      } finally {
        this.isCalling = false
      }
    },
    async setUserSettings (notification, valueToToggle) {
      let notificationToChange = notification
      notificationToChange[valueToToggle] = !notificationToChange[valueToToggle]
      try {
        await this.$store.dispatch('UsersStore/updateUserNotifications', [notificationToChange])
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'user_post_settings_notification_error' }, { root: true })
        console.error(error)
      }
    },
    async changeLanguage (lang) {
      let language = this.languageList.find(el => el.id === lang)
      this.userLanguage = language.id
      await this.$store.dispatch('UsersStore/updateUser', { id: this.userId, locale: language.locale })
      setLanguage(language.locale)
    }
  },
  async created () {
    await this.getUserSettings()
  }

}
</script>

<style scoped>
.col-sm-2 {
  margin-top: 10px;
}
</style>
